import { ETextStyleVariant, Text } from '@outdoorsyco/bonfire';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { useLocaleSettings } from '@/hooks/useLocaleSettings';

const ReCaptchaLegalNotice: React.FC = () => {
  const { locale } = useLocaleSettings();

  return (
    <Text variant={ETextStyleVariant.LegalRegular} className="mt-2 text-gray-50">
      <FormattedMessage
        defaultMessage="This site is protected by reCAPTCHA and the Google <PrivacyPolicy>Privacy Policy</PrivacyPolicy> and <TermsOfService>Terms of Service</TermsOfService> apply."
        id="jASHoz"
        values={{
          PrivacyPolicy: function PrivacyPolicy(text: React.ReactNode) {
            return (
              <a
                className="underline hover:no-underline"
                target="_blank"
                rel="noreferrer"
                href={`https://policies.google.com/privacy?hl=${locale}`}>
                {text}
              </a>
            );
          },
          TermsOfService: function TermsOfService(text: React.ReactNode) {
            return (
              <a
                className="underline hover:no-underline"
                target="_blank"
                rel="noreferrer"
                href={`https://policies.google.com/terms?hl=${locale}`}>
                {text}
              </a>
            );
          },
        }}
      />
    </Text>
  );
};

export default ReCaptchaLegalNotice;
